import Utils from './utils.js';
import OnScroll from './triggers/on-scroll';
import OnLoad from './triggers/on-load';
import Session from './triggers/session';
import ExitIntent from './triggers/exit-intent';

/**
 * class Module
 * Manage widget lazy load
 */
class Module {

	/**
	 * get lazy load elements
	 * @returns {NodeListOf<Element>}
	 */
	static getElements() {
		return document.querySelectorAll( '[' + Utils.dataSelector + ']' );
	}

	/**
	 * init lazy load trigger for an element
	 * @param {string} trigger
	 * @param {HTMLElement} element
	 */
	static initTrigger( trigger = '', element ) {
		// switch case here to support additional event triggers
		switch ( trigger ) {
			case 'onLoad':
				new OnLoad( element );
				break;
			case 'session':
				new Session( element );
				break;
			case 'exitIntent':
				new ExitIntent( element );
				break;
			case 'onScroll':
				new OnScroll( element );
				break;
		}
	}

	/**
	 * check if an element trigger is already set
	 * @param {HTMLElement} element
	 * @returns {boolean}
	 */
	static isLazyHandled( element ) {
		return 'true' === element.getAttribute( Utils.lazyHandled );
	}

	/**
	 * set handled flag on elements which are handled
	 * @param {HTMLElement} element
	 */
	static setHandledFlag( element ) {
		// set flag to avoid duplicate handlers for elements
		element.setAttribute( Utils.lazyHandled, 'true' );
	}

	/**
	 * init
	 */
	init() {
		Module.getElements().forEach( ( element ) => {
			// skip already handled elements
			if ( Module.isLazyHandled( element ) ) {
				return;
			}

			const {
				trigger = '',
				excludeSelectors = false,
			} = Utils.getData( element );

			if ( '' === trigger || '-' === trigger ) {
				return;
			}

			if ( excludeSelectors ) {
				const shouldExclude = excludeSelectors.split( ',' ).some( selector => {
					return document.querySelector( selector.trim() ).length;
				} );
				if ( shouldExclude ) {
					return;
				}
			}

			Module.setHandledFlag( element );
			Module.initTrigger( trigger, element );
		} );

		Module.initSessionHandlers();
	}

	static initSessionHandlers() {
		document.querySelectorAll( Session.actionSelectorExternal ).forEach( ( a ) => {
			let href = a.getAttribute( 'href' );

			if ( ! href ) {
				return;
			}
			let decoded = decodeURIComponent( href );
			const sessionKey = decoded.substring( decoded.indexOf( '#lazyLoad-Session-' ) + 18, decoded.indexOf( '=' ) ) || false;
			if ( ! sessionKey ) {
				return;
			}
			decoded = decoded.replace( `#lazyLoad-Session-${ sessionKey }=`, `lazyLoad-Session=` );

			a.setAttribute( 'href', '#' + encodeURIComponent( decoded ) );

			const SessionHandlerCallback = ( e ) => {
				Session.handleSession( e, sessionKey );
				a.removeEventListener( 'click', SessionHandlerCallback );
			}
			a.addEventListener( 'click', SessionHandlerCallback );
		} );
	}
}

new Module().init();
